import { Modal, Text } from "@mantine/core";
import { Fragment, useState } from "react";
import { MyButton } from "../../../UI/my-button/MyButton";
import { useColors } from "../../../../hooks/colors/useColors";
import { IconCalendarMinus, IconX } from "@tabler/icons";
import { Appointment } from "../../../../constants/model/models";
import { showLocalizedDateTime } from "../../../../services/dateAndTime/dateAndTimeUtil";
import { useAppointmentHelper } from "./useAppointmentHelper";
import { useTranslation } from "next-i18next";

type InputProps = {
  appointment: Appointment;
};
export function CancelAppointment(props: InputProps) {
  const { appointment } = props;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);
  const { colors } = useColors();
  const { confirmCancellation } = useAppointmentHelper();
  const { t, i18n } = useTranslation("common");

  function closeModal() {
    setOpenModal(false);
  }

  async function confirmAppointmentCancellation() {
    await confirmCancellation(appointment.id, setProcessing, closeModal);
  }

  return (
    <Fragment>
      <MyButton
        onClick={() => setOpenModal(true)}
        title={t("appointments.cancel")}
        textColor="white"
        color={colors.danger}
      />
      <Modal
        opened={openModal}
        onClose={closeModal}
        centered
        withCloseButton={false}
      >
        <Text className="text-center text-2xl mb-2 font-bold">
          {showLocalizedDateTime(appointment.dateTime, i18n.language, "LL, LT")}
        </Text>
        <Text className="text-center text-xl">
          {t("appointments.cancelSure")}
        </Text>
        <div className="flex justify-end gap-4 mt-4">
          <MyButton
            icon={<IconX />}
            onClick={closeModal}
            title={t("close")}
            textColor="white"
            color={colors.primary}
          />
          <MyButton
            loading={processing}
            disabled={processing}
            icon={<IconCalendarMinus />}
            onClick={confirmAppointmentCancellation}
            title={t("appointments.cancel")}
            textColor="white"
            color={colors.danger}
          />
        </div>
      </Modal>
    </Fragment>
  );
}
